"use strict";

/**************************************************************************************/
// INIT
/**************************************************************************************/
function initPage() {
	w.init();
}

initPage();